// extracted by mini-css-extract-plugin
module.exports = {"resultItem":"ResultItem_resultItem__B6q3d"};